import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Container from "react-bootstrap/Container";
import FeatherIcon from "feather-icons-react";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import useBlogApi from "../apis/blogApi";
import BlogFilters from './blogFilters';
import { deriveStatus } from "../utils/blogStatus";

const Blogs = () => {
  const history = useHistory();
  const { blogs, deleteBlog, publishBlog } = useBlogApi();
  const [clickedBlog, setClickedBlog] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [appFilter, setAppFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [languageFilter, setLanguageFilter] = useState("");

  // A handful of documents in the DB don't have a well-formed `attributes` object
  // (data-integrity issue, not a shape this app ever intentionally writes) — skip
  // them here rather than letting one bad record crash the whole list.
  const sortedBlogs = [...blogs]
    .filter((blog) => blog && blog.attributes)
    .sort((a, b) => {
      const dateA = new Date(a.attributes.createdAt || 0); // fallback if missing
      const dateB = new Date(b.attributes.createdAt || 0);
      return dateB - dateA; // latest first
    });

  const filteredBlogs = sortedBlogs.filter((blog) => {
    const appMatch = !appFilter || blog.attributes.app === appFilter;
    const typeMatch = !typeFilter || blog.attributes.type === typeFilter;
    const languageMatch = !languageFilter || blog.attributes.language === languageFilter;
    return appMatch && typeMatch && languageMatch;
  });

  const handleDeleteClick = (blog_id) => {
    deleteBlog(blog_id);
    handleModal(false);
  };

  // Close and open the delete-confirmation modal
  const handleModal = (visible, blog_id) => {
    setIsVisible(visible);
    if (visible) {
      setClickedBlog(blog_id);
    } else {
      setClickedBlog(null);
    }
  };

  const handlePublishClick = (article_id, published) => {
    if (published) {
      return;
    }
    publishBlog(article_id);
  };

  return (
    <div>
      <Container>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <BlogFilters
            appFilter={appFilter}
            setAppFilter={setAppFilter}
            typeFilter={typeFilter}
            setTypeFilter={setTypeFilter}
            languageFilter={languageFilter}
            setLanguageFilter={setLanguageFilter}
          />
          <button
            onClick={() => history.push("/blogs/new")}
            className="sa-table-btn-secondary"
          >
            <FeatherIcon icon={"plus"} className={"sa-table-icon-size"} />{" "}
            <span className={"sa-table-icon"}>ADD</span>
          </button>
        </div>
        <div className="sa-table-container ccr-user-calc-height">
          <table className="table table-borderless sa-table-width">
            <thead>
              <tr>
                <th className={"sa-table-head-sticky"}>{"Slug"}</th>
                <th className={"sa-table-head-sticky"}>{"App"}</th>
                <th className={"sa-table-head-sticky"}>{"Title"}</th>
                <th className={"sa-table-head-sticky"}>{"Sub Title"}</th>
                <th className={"sa-table-head-sticky"}>{"Lang"}</th>
                <th className={"sa-table-head-sticky"}>{"Type"}</th>
                <th className={"sa-table-head-sticky"}>{"Status"}</th>
                <th className={"sa-table-head-sticky"}>{"Created Date"}</th>
                <th className="sa-table-item-align sa-table-head-sticky"></th>
              </tr>
            </thead>
            <tbody>
              {filteredBlogs.map((blog, index) => (
                <tr key={index}>
                  <td className={"sa-table-data"}>
                    {blog.attributes.article_id}
                  </td>
                  <td className={"sa-table-data"}>
                    {blog.attributes.app || "-"}
                  </td>
                  <td className={"sa-table-data"}>{blog.attributes.title}</td>
                  <td className={"sa-table-data"}>
                    {blog.attributes.subtitle}
                  </td>
                  <td className={"sa-table-data"}>
                    {blog.attributes.language}
                  </td>
                  <td className={"sa-table-data"}>
                    {blog.attributes.type || "-"}
                  </td>
                  <td className={"sa-table-data"}>
                    {deriveStatus(blog.attributes)}
                  </td>
                  <td className={"sa-table-data"}>
                    {blog.attributes.createdAt ? new Date(blog.attributes.createdAt).toLocaleDateString() : "-"}
                  </td>
                  <td className="sa-table-item-align">
                    <div className={"sa-table-action-flex"}>
                      <div
                        className="sa-table-actions sa-action-m"
                        data-toggle="tooltip"
                        title="Edit"
                      >
                        <FeatherIcon
                          onClick={() => history.push("/blogs/edit/" + blog._id)}
                          className="table-action"
                          icon={"edit"}
                        />
                      </div>
                      <div
                        className="sa-table-actions sa-action-m"
                        data-toggle="tooltip"
                        title="Delete"
                      >
                        <FeatherIcon
                          onClick={() => handleModal(true, blog._id)}
                          className="text-red"
                          icon={"trash-2"}
                        />
                      </div>
                      {/* This re-fetches the post from Medium by article_id — only
                          meaningful for legacy Medium-sourced posts. CMS-authored posts
                          control their publish state via the Status field in the edit
                          page instead. */}
                      {blog.attributes.content_source !== "cms" &&
                        blog.attributes.content_source !== "cms-migrated" && (
                          <div
                            className="sa-table-actions sa-action-m"
                            data-toggle="tooltip"
                            title={
                              blog.attributes.published ? "Published" : "Publish"
                            }
                          >
                            <FeatherIcon //button
                              onClick={() =>
                                handlePublishClick(
                                  blog.attributes.article_id,
                                  blog.attributes.published
                                )
                              }
                              className={
                                blog.attributes.published
                                  ? "table-action text-success"
                                  : "table-action"
                              }
                              icon={
                                blog.attributes.published
                                  ? "check-circle"
                                  : "arrow-right-circle"
                              }
                            />
                          </div>
                        )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Container>

      <div className={"sa-popup-bg " + (!isVisible && "hide")}>
        <div className="sa-popup">
          <form className="sa-modal-box-style">
            <div className="sa-popup-header">
              <span className={"sa-model-heading"}>DELETE BLOG</span>
              <div
                className="sa-popup-close-icon"
                onClick={() => handleModal(false)}
              >
                <FeatherIcon className={"sa-modal-close-icon"} icon={"x"} />
              </div>
            </div>
            <div className="sa-popup-content">
              <div className="col-md-12">
                <div className="form-group">
                  <p>Are you sure you want to delete this blog?</p>
                </div>
              </div>
            </div>
            <div className="sa-popup-btn">
              <button
                type="button"
                className="sa-popup-secondary-btn-style sa-popup-cancel-btn-style"
                onClick={() => handleModal(false)}
              >
                CANCEL
              </button>
              <button
                type="button"
                className="sa-popup-secondary-btn-style sa-popup-danger-btn-style"
                onClick={() => {
                  handleDeleteClick(clickedBlog);
                }}
              >
                DELETE
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
